// Stable tokens prefixed onto pre-signup error messages by the admin-api Cognito triggers.
// Cognito wraps them in UserLambdaValidationException; Amplify surfaces the message as-is.
const PRE_SIGNUP_ERROR_MESSAGES: Record<string, string> = {
    GOOGLE_ACCOUNT_EXISTS:
        'A Google-linked account already exists for this email. Please use "Sign in with Google" instead.',
    NO_SLATE_ACCOUNT: 'No Slate account exists for this email. Please request an invitation from your team admin.',
    UNVERIFIED_NATIVE_ACCOUNT_EXISTS:
        'An unverified account exists for this email. Please reset your password to verify your email, then sign in with Google.',
    AMBIGUOUS_EMAIL_MATCH:
        'Multiple accounts exist for this email. Please contact support to resolve before signing in.',
    GOOGLE_EMAIL_UNVERIFIED:
        'Your Google account email is not verified. Please verify it with Google, then try signing in again.',
    INVITATION_NOT_FOUND: 'No invitation found for this email. Please ask your team admin to invite you.',
    NO_EMAIL_ATTRIBUTE: "We couldn't read an email from your sign-in provider. Please contact support.",
    INVALID_USERNAME: 'Sign-in request was malformed. Please try again or contact support.',
    PERSONAL_EMAIL_DOMAIN: 'Please sign up with your work email. Personal email addresses are not supported.',
};

export function friendlyPreSignupError(rawError: string | null | undefined): string | null {
    if (!rawError) {
        return null;
    }
    for (const [code, message] of Object.entries(PRE_SIGNUP_ERROR_MESSAGES)) {
        if (rawError.includes(code)) {
            return message;
        }
    }
    return rawError;
}
